import { render, staticRenderFns } from "./AdminAccountView.vue?vue&type=template&id=f068ac3a&"
import script from "./AdminAccountView.vue?vue&type=script&lang=ts&"
export * from "./AdminAccountView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports